module.exports = __webpack_public_path__ + "img/617e069.png";